import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { SocialProviderButton } from 'frontend-component-library';

class OAuthButton extends PureComponent {
  handleClick = () => {
    const { provider, onClick } = this.props;
    onClick(provider);
  };
  render() {
    const { provider, text, disabled } = this.props;
    return (
      <SocialProviderButton
        provider={provider}
        text={text}
        disabled={disabled}
        onClick={this.handleClick}
      />
    );
  }
}

OAuthButton.propTypes = {
  provider: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

OAuthButton.defaultProps = {
  disabled: true,
};

export default OAuthButton;



// WEBPACK FOOTER //
// ./src/Components/Auth/OAuthButton.js